"use strict";
import {find, findAllIn, addClass, findIn, hasClass, setAttribute, removeAttribute} from "@elements/dom-utils";
import TerracePlanner from "../index";

let frameContainer,
    frameBox;

/**
 * determines whether the selected set can be built as a frame and shows/hides the checkbox accordingly
 *
 * @param setId
 */
export function selectSet(setId) {
    let setNode = find('.js-planner__substructure[data-set-id="' + setId + '"]');
    let isFrame = setNode.getAttribute('data-frame');
    let frameType = setNode.getAttribute('data-frame-type');
    frameContainer = findIn('#frameSelectionContainer', TerracePlanner.element);

    if (isFrame) {
        if(frameType === 'select' && !findIn('.js-planner__construction-input', frameContainer)
            || frameType === 'checkbox' && !findIn('.js-planner__construction-input', frameContainer
            && findIn('.js-planner__construction', frameContainer)))
        {
            findIn('.js-planner__construction', frameContainer).innerHTML = find('.js-frame-selection-template[data-type="'+ frameType +'"]').innerHTML;
        }

        removeAttribute('hidden', frameContainer)
        // removeClass('hidden', frameContainer);
        frameBox = find('#frameBox');
    } else {
        setAttribute('hidden', true, frameContainer)
        // addClass('hidden', frameContainer);
    }

    let hasLevelingFeet = setNode.getAttribute('data-has-leveling-feet');
    let slopeSlide = find('#slopeSlide');

    findAllIn('.js-planner__slope-input[data-slope="min"]', slopeSlide).map((input) => {
        setAttribute('min', setNode.getAttribute('data-leveling-min'), input);
        setAttribute('max', setNode.getAttribute('data-leveling-max'), input);
    });
    // setAttribute('min', setNode.getAttribute('data-leveling-min'), find('#slopeMin'));
    // setAttribute('max', setNode.getAttribute('data-leveling-max'), find('#slopeMin'));


    findAllIn('.js-planner__slope-input[data-slope="max"]', slopeSlide).map((input) => {
        setAttribute('min', setNode.getAttribute('data-leveling-min'), input);
        setAttribute('max', setNode.getAttribute('data-leveling-max'), input);
    });
    // $('#slopeMax').prop('min',setNode.data('leveling-min')).attr('min',setNode.data('leveling-min'));
    // $('#slopeMax').prop('max',setNode.data('leveling-max')).attr('max',setNode.data('leveling-max'));

    find('#maxHeightReached').innerHTML = setNode.getAttribute('data-leveling-max-message');
    find('#minHeightReached').innerHTML = setNode.getAttribute('data-leveling-min-message');
    find('#slopeDimensionsHint').innerHTML = setNode.getAttribute('data-dimensions-hint');
    // $('#slopeDimensionsHint').html(setNode.data('dimensions-hint'));

    if(hasLevelingFeet) {
        removeAttribute('hidden', slopeSlide);
    } else {
        setAttribute('hidden', true, slopeSlide);
    }
}

/**
 * returns whether the checkbox is checked, false if checkbox is unchecked or hidden
 *
 * @return Boolean
 */
export function isFrame() {
    frameBox = findIn('#frameBox', TerracePlanner.element);
    frameContainer = findIn('#frameSelectionContainer', TerracePlanner.element);

    let isFrameSelected = (frameBox && frameBox.tagName === 'INPUT' && frameBox.checked) || (frameBox && frameBox.tagName === 'SELECT' && frameBox.value);
    return !hasClass('hidden', frameContainer) && isFrameSelected;
}